import {Abstract, tpl} from "./Abstract";
import {IRouteDefinitionParams} from "../../../index";
import pubsub from "../../../pubsub";

export const template = tpl;

export class viewModel extends Abstract {
    constructor(params: IRouteDefinitionParams) {
        super(params);
        pubsub.on(this, 'object.needs.refresh', this.init.bind(this));
        if (this.__routeDef.fetchRouteDef) {
            this.init();
        } else {
            this.isReady(true);
        }
    }
}
